import React, { useCallback } from 'react';
import classNames from 'classnames/bind';
import { ChipsGroup } from '@carnica/ui-kit';
import { Metric } from "../../../../metric";
import { EMetricBlockName } from "../../../../types";
import { ChipsElement } from "./Chips";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var ChipsBlock = function ChipsBlock(_ref) {
  var taps = _ref.taps,
    onSearch = _ref.onSearch;
  var handleClick = useCallback(function () {
    var relatedSearch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    onSearch === null || onSearch === void 0 ? void 0 : onSearch(relatedSearch);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return /*#__PURE__*/React.createElement("div", {
    className: cx('block-chips'),
    "data-t-id": "blocks-ChipsBlock"
  }, /*#__PURE__*/React.createElement(Metric, {
    asChild: true,
    data: JSON.stringify({
      block_name: EMetricBlockName.keywords
    }),
    events: {
      headerMetric: ['handleViewSearchBlock']
    },
    mode: "viewport",
    once: true
  }, /*#__PURE__*/React.createElement(ChipsGroup, {
    className: cx('chips'),
    items: taps,
    layout: "wrap",
    renderItem: function renderItem(item) {
      return /*#__PURE__*/React.createElement(ChipsElement, {
        handleClick: handleClick,
        item: item,
        key: item.label
      });
    },
    "data-t-id": "blocks-ChipsBlock"
  })));
};